import { useMemo } from 'react';
import { FavoriteToggleIcon, TableProps } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { useStarredEntities } from '@backstage/plugin-catalog-react';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { CatalogExplorerPage } from './CatalogExplorerPage';
import { pagerDutyTeamColumns } from './catalogColumns';

const PAGERDUTY_URL_ANNOTATION = 'tomtom.com/pagerduty-url';

export const PagerDutyTeamsExplorerPage = () => {
  const { isStarredEntity, toggleStarredEntity } = useStarredEntities();

  // Replaces CatalogTable's default actions, which also offer view and edit
  // links that PagerDuty team entities carry no annotations for.
  const actions: TableProps<CatalogTableRow>['actions'] = useMemo(
    () => [
      ({ entity }) => {
        const url = entity.metadata.annotations?.[PAGERDUTY_URL_ANNOTATION];
        return {
          icon: () => <OpenInNewIcon fontSize="small" />,
          tooltip: 'Open in PagerDuty',
          disabled: !url,
          onClick: () => {
            if (url) {
              window.open(url, '_blank', 'noopener,noreferrer');
            }
          },
        };
      },
      ({ entity }) => {
        const starred = isStarredEntity(entity);
        return {
          cellStyle: { paddingLeft: '1em' },
          icon: () => <FavoriteToggleIcon isFavorite={starred} />,
          tooltip: starred ? 'Remove from favorites' : 'Add to favorites',
          onClick: () => toggleStarredEntity(entity),
        };
      },
    ],
    [isStarredEntity, toggleStarredEntity],
  );

  return (
    <CatalogExplorerPage
      initialKind="component"
      initialType="pagerduty-team"
      columns={pagerDutyTeamColumns}
      actions={actions}
    />
  );
};
